// Survey actions
import _ from 'underscore'
import { orderBy, find, map, filter, forEach, last, indexOf } from 'lodash'
import router from '../../router'

export default {

  // Read survey data
  async readSurvey ({ commit, dispatch, getters, rootState }, payload) {
    const params = payload && payload.data ? payload.data : {}
    let lastAnswered = null
    let survey = null
    let statements = null

    dispatch('root/loadingModalActive', true, { root: true })

    await axios
      .get(process.env.VUE_APP_API_URL + 'surveys/' + payload.slug, {
        params: params
      })
      .catch (error => {
        router.push('/surveys/' + payload.slug + '/login')
      })
      .then(response => {
        response.data.data.statement_surveys = response.data.data.statement_surveys.data

        const userId = rootState.root.user.id
        statements = orderBy(response.data.data.statement_surveys, ['sequence'])
        const answeredStatements = filter(statements, statement => {
          return !!find(statement.statement_responses.data, { participant_id: userId })
        })

        forEach(answeredStatements, answer => {
          const participantResponse = find(answer.statement_responses.data, { participant_id: userId })
          let answeredStatement = find(response.data.data.statement_surveys, { id: answer.id })
            if(participantResponse && answeredStatement) {
              answeredStatement.response_code = participantResponse.response_code
              answeredStatement.response_text = participantResponse.response_text
              answeredStatement.extended_response_text = participantResponse.extended_response_text
            }
        })

        lastAnswered = _.last(answeredStatements)

        survey = response.data.data
      })

      await commit('SET_SURVEY', survey)

      if (lastAnswered)
      {
        await dispatch('goToLastInSection', lastAnswered.capability_section - 1)
        //TODO works with successive capability_section numbering starting from 1
      }

      dispatch('root/loadingModalActive', false, { root: true })
      dispatch('survey/createListener', true, { root: true })

      dispatch('subscribeToCloseSectionEvents')
      dispatch('subscribeToUpdateResponseEvents')
  },

  // Change response
  response ({ commit }, payload) {
    commit('RESPONSE', payload)
  },

  // Save response
  saveResponse ({ state, dispatch }, payload) {
    const statement = _.findWhere(state.survey.statement_surveys, { id: payload.statementId })

    return axios
      .post(process.env.VUE_APP_API_URL + 'surveys/' + state.survey.url_slug + '/statements/' + payload.statementId + '/responses', {
        response: {
          value: statement.response_code,
          label: statement.response_text,
          extended_text: statement.extended_response_text
        }
      })
      .then(response => {
        dispatch('updateResponse',response.data.data)
        return response
      })
  },

  nextSection ({ commit, state, getters }, payload) {
    const { pointers } = state

    commit('SECTION', pointers.section + 1)
    commit('STATEMENT', -1)
    commit('CAN_DISPLAY_SECTION_RESULTS', false)
  },

  nextStatement ({ commit, state, getters, dispatch }, payload) {
    const { pointers } = state
    const { getCurrentSection } = getters
    commit('STATEMENT', pointers.statement + 1)
  },

  async previousStatement ({ commit, state, getters, dispatch }, payload) {
    const { pointers } = state

    if (pointers.statement > 0) {
      commit('STATEMENT', pointers.statement - 1)
    }
  },

  saveAndNextStatement ({ commit, state, getters, dispatch }, payload) {
    const { pointers } = state
    const { getCurrentStatement, getCurrentSection } = getters

    if (getCurrentStatement) {
      dispatch('saveResponse', {
        statementId: getCurrentStatement.id
      })
    }

    commit('STATEMENT', pointers.statement + 1)
  },

  async goToLastInSection ({ commit, state, getters, dispatch }, payload){
    const { pointers } = state
    const { getSectionByIndex, isLastSection, isSectionEnd } = getters

    const section = getSectionByIndex(payload)
    const firstUnAnswered = find(section.statements, statement => !statement.response_code)
    const index = indexOf(section.statements, firstUnAnswered)

    await commit('SECTION', payload)
    if(firstUnAnswered) {
      if(index == 0) { // go to section start screen if there are no answered statements in the section
        await commit('STATEMENT', -1)
      } else { // go to firstUnAnswered
        await commit('STATEMENT', index)
      }
    } else { // go to next section or final sequence
      if (isLastSection == true) {
        const slug = router.currentRoute.params.slug
        router.push({ name: 'final', params: { slug } })
      } else {
        await commit('SECTION', payload + 1)
      }      
    }
  },

  async goToSection({ commit, state, getters, dispatch }, payload) {
    const { pointers } = state
    const { getSectionByIndex } = getters

    const section = getSectionByIndex(payload)
    const firstUnAnswered = find(section.statements, statement => !statement.response_code)
    const index = indexOf(section.statements, firstUnAnswered)

    await commit('SECTION', payload)
    if (firstUnAnswered) {
      if (index == 0) { // go to section start screen if there are no answered statements in the section
        await commit('STATEMENT', -1)
      } else { // go to firstUnAnswered
        await commit('STATEMENT', index)
      }
    } else { // go to results
      await commit('STATEMENT', section.statements.length)
    }
  },

  setResponse ({ commit, state, getters, dispatch }, payload){
    commit('SET_RESPONSE', state.data.data)
  },

  async createListener({ commit, state, getters, dispatch, rootState }, payload) {
    if (!getters.pusher) {
      let pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
        cluster: process.env.VUE_APP_PUSHER_CLUSTER,
        authEndpoint: process.env.VUE_APP_API_URL + 'pusher/auth',
        auth: {
          headers: {
            'Authorization': 'Bearer ' + rootState.root.auth.accessToken
          },
          params: {
            'surveyId': state.survey.id,
            'participantId': rootState.root.user.id
          }
        },
      })

      commit('PUSHER', pusher)
    }
  },

  subscribeToCloseSectionEvents({ commit, state, getters, dispatch, rootState }) {
    const pusher = getters.pusher
    pusher.subscribe('private-closeSection.' + state.survey.id)
    pusher.bind('App\\Events\\CloseSection', e => {
      dispatch('setSectionResultsDisplay', true)
    })
  },

  subscribeToUpdateResponseEvents({ commit, state, getters, dispatch, rootState }) {    
    const pusher = getters.pusher
    pusher.subscribe('private-responses.' + state.survey.url_slug)
    pusher.bind('App\\Events\\SurveyResponseUpdated', e => {
      dispatch('updateResponse', e.response.data)
    })
  },

  setSectionResultsDisplay({ commit }, payload) {
    commit('CAN_DISPLAY_SECTION_RESULTS', payload)
  },

  updateResponse ({ commit, state, getters, dispatch }, payload){
    var statementResponseUpdated = 0
    state.survey.statement_surveys.forEach(function (statement_survey, statement_index) {
      if (statement_survey.id == payload.statement_survey_id){
        statementResponseUpdated = 0
        statement_survey.statement_responses.data.forEach(function (statement_response, response_index) {
          if (statement_response.participant_id == payload.participant_id){
            commit('UPDATE_RESPONSE', {
              statement_index: statement_index,
              response_index: response_index,
              response: payload
            })
            statementResponseUpdated = 1
            return true
          }
        })
        if (!statementResponseUpdated){
          commit('UPDATE_RESPONSE', {
            statement_index: statement_index,
            response: payload
          })
        }
      }
    })
  },
  async updateResponseFromSectionEnd ({ commit, state, dispatch }, payload) {
    const result = await axios
      .post(process.env.VUE_APP_API_URL + 'surveys/' + state.survey.url_slug + '/statements/' + payload.statementId + '/responses', {
        response: {
          value: payload.response_code,
          label: payload.response_text,
          extended_text: payload.extended_response_text
        }
      })

    dispatch('updateResponse', result.data.data)
   },

  finalSequence({ state, dispatch }, payload) {
    dispatch('loadingModalActive', true)
    let success = null

    return axios
      .post(process.env.VUE_APP_API_URL + payload.url, payload)
      .catch(error => {
        dispatch('openErrorsModal', {
          content: error.response.data.error
        })
      })
      .then(response => {
        success = response
        dispatch('loadingModalActive', false)
        return success
      })
  },

   /*async finalSequence ({ dispatch }, payload) {
    dispatch('loadingModalActive', true)
    let success = null

     return axios
       .post(process.env.VUE_APP_API_URL + payload.url, payload
       })
       .then(response => {
         success = response
         return success
       })

    try {
      const response = await axios.post(process.env.VUE_APP_API_URL + payload.url, payload)
        success = response
      } catch(error) {
        dispatch('openErrorsModal', {
          content: error.response.data.error
        })
      } finally {
        dispatch('loadingModalActive', false)
      }

    return success
  },*/
  loadingModalActive({ commit }, value) {
    commit('LOADING_MODAL_ACTIVE', value)
  },
  openErrorsModal({ commit }, payload) {
    commit('OPEN_ERRORS_MODAL', payload)
  },
  closeErrorsModal({ commit }) {
    commit('CLOSE_ERRORS_MODAL')
  },
  logout({ commit }) {
    commit('LOGOUT')
    commit('POPULATE_SURVEY_AT_STATE')
  },
}